import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-password-validation',
  standalone: true,
  templateUrl: './password-validation.component.html',
  styleUrl: './password-validation.component.css',
  imports: [CommonModule, TranslateModule]
})
export class PasswordValidationComponent implements OnChanges {

  @Input() password: string = '';
  @Output() validityChange = new EventEmitter<boolean>();

  isValid: boolean = false;

  validationRules = [
    {
      key: 'length',
      labelKey: 'password-validation.rules.length',
      check: (pwd: string) => pwd.length >= 8
    },
    {
      key: 'uppercase',
      labelKey: 'password-validation.rules.uppercase',
      check: (pwd: string) => /[A-Z]/.test(pwd)
    },
    {
      key: 'lowercase',
      labelKey: 'password-validation.rules.lowercase',
      check: (pwd: string) => /[a-z]/.test(pwd)
    },
    {
      key: 'digit',
      labelKey: 'password-validation.rules.digit',
      check: (pwd: string) => /\d/.test(pwd)
    },
    {
      key: 'special',
      labelKey: 'password-validation.rules.special',
      check: (pwd: string) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd)
    }
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['password']) {
      this.validatePassword();
    }
  }

  validatePassword(): void {
    this.isValid = this.validationRules.every(rule => rule.check(this.password));
    this.validityChange.emit(this.isValid);
  }

  isRuleValid(rule: any): boolean {
    return rule.check(this.password);
  }

}
